import Vue from 'vue'
import App from '@/App.vue'
import mixins from '@/mixins'
import router from '@/router'
import store from '@/store'

Vue.config.productionTip = false

import '@/lib/axios'
import '@/lib/font'
import '@/lib/bootstrap'
import '@/lib/icons'

(async () => {
  if (window.innerWidth > 576) {
    store.commit('setSidebar', true)
    store.commit('setDevice', 'desktop')
  } else {
    store.commit('setSidebar', false)
    store.commit('setDevice', 'mobile')
  }
  new Vue({
    mixins: [mixins],
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})()
